import { ThemeProvider, Toaster, TooltipProvider } from "@motleyhand/design"
import { ThemeProvider as MuiThemeProvider } from "@mui/material"
import type { ReactNode } from "react"
import { createTheme } from "@mui/material/styles"
import type {} from "@mui/x-data-grid-pro/themeAugmentation"
import { LicenseInfo } from "@mui/x-license"

LicenseInfo.setLicenseKey(
  "bf44ff27fdbff4157f43f8ba366e3a49Tz0xMjAyMjcsRT0xNzkxNjc2Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
)

const theme = createTheme({
  colorSchemes: {
    light: true,
    dark: true,
  },
})

type Props = {
  children: ReactNode
}

export default function UiProvider({ children }: Props) {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <MuiThemeProvider theme={theme}>
          {children}
          <Toaster />
        </MuiThemeProvider>
      </TooltipProvider>
    </ThemeProvider>
  )
}
